import { createContext } from "react"

export const TutorCardApplicationContext = createContext(null)
export const TutorCardActionsContext = createContext({})
export const TutorCardConfigsContext = createContext([])
